import { Appointment, SaveAppointment } from 'types/Appointment';
import { SaveOrder } from 'types/Order';

export interface Booking {
    id: number;
    uuid: string;
    marketplaceId: number;

    staffId: number;
    customerId: number;

    appointments: Array<Appointment>;
}

export type SaveBooking = Omit<Booking, 'id' | 'appointments'> & {
    order?: SaveOrder;
    appointments: Array<SaveAppointment>;
};

export enum BookingChannel {
    ONLINE_BOOKING = 'online-booking'
}

export enum BookingStatus {
    REQUESTED = 0,
    CONFIRMED = 1,
    PENDING = 11
}
